import React from 'react';
import T from 'prop-types';

function Button(props) {
  const { text, textOnlySr, ...rest } = props;
  return (
    <button {...rest}>
      {textOnlySr ? <span className="show-for-sr">{text}</span> : text}
    </button>
  );
}

Button.defaultProps = {
  type: 'button',
};

Button.propTypes = {
  type: T.oneOf(['button', 'submit', 'reset']),
  onClick: T.func,
  textOnlySr: T.bool,
  text: T.node,
};

export default Button;
